import { useQuery } from "@tanstack/react-query"
import { queryClient as qc } from "keys"
import { useDispatch } from "react-redux"
import { getLanguagesFetch } from "store/middlewares/testTakers.crud"
import { getBatteriesFetch, getCategoriesFetch } from "store/middlewares/assessment.crud"
import { getRolesFetch, getUsersOptionsFetch } from "store/middlewares/user.crud"
import { AbilityContext } from "components/Permissions/Can"
import { useContext } from "react"
import { allRoles, openRoles } from "keys/roles"
import { getCitiesFetch } from "store/middlewares/affiliation.crud"
import actions from "store/actions"

const useGetLanguages = () => {
    const dispatch = useDispatch()

    return useQuery({
        queryKey: [qc.languages],
        queryFn: async () => {
            const { data } = await getLanguagesFetch()
            dispatch(actions.setLanguages(data))
            return data
        },
        staleTime: Infinity,
        enabled: false
    })

}

const useGetCategories = () => {
    return useQuery({
        queryKey: [qc.categories],
        queryFn: async () => {
            const { data } = await getCategoriesFetch()
            return data
        },
        enabled: false
    })
}

const useGetBatteries = () => {
    return useQuery({
        queryKey: [qc.batteries],
        queryFn: async () => {
            const { data } = await getBatteriesFetch()
            return data
        },
        enabled: false
    })
}

const useGetRoles = () => {
    const ability = useContext(AbilityContext)
    const isSuperuser = ability.can("manage", "super-user")

    return useQuery({
        queryKey: [qc.roles],
        queryFn: async () => {
            const { data } = await getRolesFetch()
            if (isSuperuser)
                return data
            else {
                let openRoleList = data.filter(({ name }) => openRoles.includes(name))
                return openRoleList
            }
        },
        enabled: false
    })
}


const useGetCities = () => {
    return useQuery({
        queryKey: [qc.cities],
        queryFn: async () => {
            const { data } = await getCitiesFetch()
            return data
        },
        enabled: false
    })
}

const useGetUsers = () => {
    return useQuery({
        queryKey: [qc.userOptions],
        queryFn: async () => {
            const { data } = await getUsersOptionsFetch()
            return data
        },
        enabled: false
    })
}


export default { useGetUsers, useGetCities, useGetRoles, useGetLanguages, useGetBatteries, useGetCategories }